import React,{useState} from 'react';
import Footer from '../components/Footer';
import Navbar from '../components/Navbar';
import Navbar2 from '../components/Navbar2';
import Sidebar from '../components/Sidebar';
import SignUpPage from '../components/SignUp';



function SignUp() {
    const [isOpen,setIsOpen]= useState(false);
    const toggle= ()=>{
        setIsOpen(!isOpen);
    }
    return (
        <div>
            <Sidebar isOpen={isOpen} toggle={toggle} />
            <Navbar2 toggle={toggle} />  
            <SignUpPage />


            <Footer />
        </div>
    )
}

export default SignUp
